export default __webpack_public_path__ + "static/18-a0df975f3f58fc6f76fb3f76f8180540.webp";